import { Link } from "@tanstack/react-router";

export type Crumb = { label: string; to?: string };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav className="kk-breadcrumbs" aria-label="Você está aqui">
      <div className="kk-container">
        <ol>
          <li>
            <Link to="/">Início</Link>
          </li>
          {items.map((item) => (
            <li key={item.label}>
              {item.to ? <Link to={item.to}>{item.label}</Link> : <span aria-current="page">{item.label}</span>}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
